import { styled } from '@mui/material';

import { PaginatorIconButton } from './PaginatorIconButton';
import { CursorPaginatorProps } from './types';
import { shouldForwardProp } from '../../../../utils/shouldForwardProp';
import { CaretLeft, CaretRight } from '../../../icons';

const Root = styled('div', {
  name: 'DsPaginator',
  slot: 'Root',
  target: 'DsPaginator-Root',
  shouldForwardProp,
  overridesResolver: (_, styles) => [styles.root],
})<{ ownerState: CursorPaginatorProps }>({});

const Text = styled('span', {
  name: 'DsPaginator',
  slot: 'Text',
  target: 'DsPaginator-Text',
  shouldForwardProp,
  overridesResolver: (_, styles) => [styles.text],
})<{ ownerState: CursorPaginatorProps }>({});

const IconBack = styled(CaretLeft, {
  name: 'DsPaginator',
  slot: 'Icon',
  target: 'DsPaginator-Icon DsPaginatorIconBack',
  shouldForwardProp,
  overridesResolver: (_, styles) => [styles.icon, styles.iconBack],
})<{ ownerState: CursorPaginatorProps }>({});

const IconForward = styled(CaretRight, {
  name: 'DsPaginator',
  slot: 'Icon',
  target: 'DsPaginator-Icon DsPaginatorIconForward',
  shouldForwardProp,
  overridesResolver: (_, styles) => [styles.icon, styles.iconForward],
})<{ ownerState: CursorPaginatorProps }>({});

export const CursorPaginator = (props: CursorPaginatorProps) => {
  const {
    fetchNextPage,
    fetchPreviousPage,
    size,
    sx,
    infinite,
    canGoForward,
    canGoBack,
  } = props;
  const { recordsCount, from, to } = props;

  return (
    <Root ownerState={props} sx={sx}>
      <Text ownerState={props}>
        {from}-{to}
        {!infinite && ` of ${recordsCount}`}
      </Text>
      <PaginatorIconButton
        className="DsPaginator-IconButtonBack"
        onClick={fetchPreviousPage}
        disabled={!canGoBack}
        size={size}
        data-testid="back button"
      >
        <IconBack ownerState={props} />
      </PaginatorIconButton>
      <PaginatorIconButton
        className="DsPaginator-IconButtonForward"
        onClick={fetchNextPage}
        disabled={!canGoForward}
        size={size}
        data-testid="forward button"
      >
        <IconForward ownerState={props} />
      </PaginatorIconButton>
    </Root>
  );
};
